// extracted by mini-css-extract-plugin
export var validUntil = "CruiseFares-module--valid-until--a5ef3";